import { render, staticRenderFns } from "./DetailPlantePDF.vue?vue&type=template&id=ed5b5dda"
import script from "./DetailPlantePDF.vue?vue&type=script&lang=js"
export * from "./DetailPlantePDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports